<icc-list [searchable]="true" [items]="glassTypes"
          [itemTemplate]="'itemImgTitle'"
          itemImgHeight="medium"
          (select)="selectType($event)"
          [selected]="selectedType"
          ></icc-list>
